import React, { useContext } from 'react';
import { useQuery } from 'react-apollo-hooks';
import { NotebookContext } from '../../context/NotebookContext';
import { TimeContext } from '../../context/time';
import { Measurement } from '../../lib/helpers/measurement';
import { MeasurementHelper } from '../../lib/helpers/measurementHelper';
import { measurementsQuery } from '../../queries/measurements';
import {
  MeasurementsQuery,
  MeasurementsQueryVariables
} from '../../queries/__generated__/MeasurementsQuery';
import TrendIndicator from '../charts/TrendIndicator';
import BinaryData from './viz/BinaryData';
import FiverData from './viz/FiverData';
import NumberData from './viz/NumberData';
import TrafficLightData from './viz/TrafficLightData';
import { SummaryRowProps } from './types';
import even from '../../images/trend-even.svg';
import { LoadingIcon } from '../utils';

const SummaryRow: React.FC<SummaryRowProps> = ({ item, tracker, index }) => {
  const { notebook } = useContext(NotebookContext);
  const timeContext = useContext(TimeContext);

  let subjectIds: string[];
  if (item.type === 'GROUP') {
    const subjects = item.subjects || [];
    subjectIds = subjects.map(s => s.id);
  } else {
    subjectIds = [item.id];
  }

  const { data, loading } = useQuery<MeasurementsQuery, MeasurementsQueryVariables>(
    measurementsQuery,
    {
      variables: {
        input: {
          notebookId: notebook.id,
          trackerIds: [tracker.id],
          subjectIds
        }
      }
    }
  );

  if (loading)
    return (
      <div
        key={tracker.id}
        className={`flex justify-between items-center b--light-gray pv1 ${index > 0 && 'bt'}`}
        style={{ height: 47 }}
      >
        <div className="flex items-center w-100">
          <img src={even} style={{ width: 10, height: 10 }} alt="Trending Even" />
          <div className="flex-auto flex items-center justify-between">
            <div className="ml3">
              <h3 className="f7 fw4 lh-title measure-narrow mt0 mb1">{tracker.name}</h3>
            </div>
            <LoadingIcon size={20} color="navy" />
          </div>
        </div>
      </div>
    );

  const measurements = data!.measurements.map(m => new Measurement(m));
  const measurementHelper = new MeasurementHelper(measurements, timeContext.range);
  const measurementCount = measurementHelper.measurementCount;

  return (
    <div
      key={tracker.id}
      className={`flex justify-between items-center b--light-gray pv1 ${index > 0 && 'bt'}`}
      style={{ height: 47 }}
    >
      <div className="flex items-center">
        <TrendIndicator helper={measurementHelper} trackerType={tracker.type} />
        <div className="flex flex-column items-center">
          <div className="ml3">
            <h3 className="f7 fw4 lh-title measure-narrow mt0 mb1">{tracker.name}</h3>
          </div>
        </div>
      </div>

      {/* Data */}
      <div>
        {tracker.type === 'BINARY' && !!measurementCount && (
          <BinaryData helper={measurementHelper} />
        )}
        {tracker.type === 'FIVER' && !!measurementCount && (
          <>
            <FiverData helper={measurementHelper} />
          </>
        )}
        {tracker.type === 'INTEGER' && !!measurementCount && (
          <NumberData helper={measurementHelper} />
        )}
        {tracker.type === 'TRAFFIC_LIGHT' && !!measurementCount && (
          <TrafficLightData helper={measurementHelper} />
        )}
        {measurementCount === 0 && <p className="f6 display mv0 light-tan">—</p>}
      </div>
    </div>
  );
};

export default SummaryRow;
